import { Box } from '@mui/material'
import { RegisterOptions, useController, UseFormReturn } from 'react-hook-form'
import TimeField from 'react-simple-timefield'
import InputLabelFieldTime from '../InputLabelFieldTime'

interface TimeFieldControlProps {
  required?: boolean
  name: string
  form?: UseFormReturn<any, any>
  style?: {
    height?: number
    borderRadius?: string
    width?: {
      xs?: string | number
    }
    marginTop?: string
    backgroundColor?: string
  }
  padding?: string
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >
  type?: string | undefined
  placeholder?: any
  label?: string
  autoFocus?: boolean
  inputRef?: any
  disabled?: boolean
  isRequired?: boolean
  value?: any
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  showSecond?: boolean
  color?: string
}
const TimeFieldControl = ({
  isRequired,
  required,
  name,
  form,
  placeholder,
  label,
  padding,
  type,
  style,
  inputRef,
  disabled,
  value,
  onChange,
  color,
  showSecond = false,
  ...props
}: TimeFieldControlProps) => {
  const { control } = form || { control: null }
  const { field } = control
    ? // eslint-disable-next-line
      useController({ name, control })
    : {
        field: { onChange, value, onBlur: undefined, ref: undefined },
      }

  return (
    <Box borderRadius="8px">
      <TimeField
        value={field.value ?? '00:00'}
        onChange={field.onChange}
        style={style}
        input={
          <InputLabelFieldTime
            name=""
            label={label}
            placeholder={placeholder}
            backgroundColor={color}
          />
        } // {Element}  default: <input type="text" />
        colon=":" // {String}   default: ":"
        showSeconds={showSecond} // {Boolean}  default: false
      />
    </Box>
  )
}
export default TimeFieldControl
